module.exports = __webpack_public_path__ + "static/media/Phone.de2c91c2.svg";